import React from 'react';
import MuiSelect, { SelectProps as MuiSelectProps } from '@mui/material/Select';

/**
 * Design System Select
 * Adds support for color and background variants.
 */
export type SelectProps = MuiSelectProps & {
  colorVariant?: string;
  backgroundVariant?: string;
};

const DSSelect = React.forwardRef<HTMLDivElement, SelectProps>(
  function DSSelect(
    { colorVariant = 'default', backgroundVariant = 'default', className = '', ...props },
    ref,
  ) {
    let variantClass = '';
    if (colorVariant === 'white' && backgroundVariant === 'transparent') {
      variantClass = 'ds-select-white-transparent';
    }
    // Add more variants as needed
    return (
      <MuiSelect ref={ref} className={`${variantClass} ${className}`} {...props} />
    );
  },
);

export default DSSelect;
